import store from '../vuex/store'

export default router => {
  // Check if user is logged or authenticate  when need it
  router.beforeEach((to, from, next) => {
    const REQUIRE_AUTH = to.matched.some(record => record.meta.requireAuth)

    if (REQUIRE_AUTH) {
      if (!Object.keys(store.getters.getMe).length) {
        return store.dispatch('me')
          .then(next)
          .catch(() => next({
            path: '/login'
          }))
      }
    }

    return next()
  })

  // Check if user is admin when need it
  router.beforeEach((to, from, next) => {
    const REQUIRE_ADMIN = to.matched.some(record => record.meta.requireAdmin)

    if (REQUIRE_ADMIN && !store.getters.isAdmin) {
      return next({
        path: '/'
      })
    }

    return next()
  })
}



// WEBPACK FOOTER //
// ./src/router/hooks.js